export default "__VITE_ASSET__DPLxfP5R__"